export enum ZoneType {
    TEMPORARY = 'TEMPORARY',
    PERMANENT = 'PERMANENT',
}
